import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translate } from 'react-polyglot';

import { FormContext } from '../../context/form-context';

import growthIcon from '../../assets/images/dashboard/growth.svg';
import dietDiaperIcon from '../../assets/icons/learn/fluids-feeding.svg';
import visitationIcon from '../../assets/images/dashboard/visitation.svg';
import milestoneIcon from '../../assets/images/dashboard/bathing.svg';
import sleepIcon from '../../assets/icons/learn/nurturing.svg';

import './TrackerChooser.css';

function TrackerChooser(props) {
  const {
    showMilestoneModal,
    showDietDiaperModal,
    showGrowthModal,
    showActivitiesModal,
    showSleepModal,
    visible,
    setExpanded,
    setNoBabiesModal,
    babies,
    t
  } = props;

  const formContext = useContext(FormContext);

  useEffect(() => {
    if (babies.length === 0 && visible) {
      setExpanded(false);
      setNoBabiesModal(true);
    }
  }, [visible])

  return (
    <div
      className={classNames(
        { 'tracker-chooser-options': true },
        { '--open': visible }
      )}
    >
      <button
        className="tracker-chooser-button"
        onClick={() => {
          setExpanded(false);
          formContext.clearFormContext();
          showActivitiesModal();
        }}
      >
        <div className="tracker-chooser-button__icon-container">
          <img
            className="tracker-chooser-button__icon"
            src={visitationIcon}
            alt=""
          />
        </div>{' '}
        <div className="tracker-chooser-button__title">
          Activities
        </div>
      </button>
      <button
        className="tracker-chooser-button"
        onClick={() => {
          setExpanded(false);
          formContext.clearFormContext();
          showSleepModal();
        }}
      >
        <div className="tracker-chooser-button__icon-container">
          <img
            className="tracker-chooser-button__icon"
            src={sleepIcon}
            alt=""
          />
        </div>{' '}
        <div className="tracker-chooser-button__title">
          {t('tracker.sleep')}
        </div>
      </button>
      <button
        className="tracker-chooser-button"
        onClick={() => {
          setExpanded(false);
          formContext.clearFormContext();
          showDietDiaperModal();
        }}
      >
        <div className="tracker-chooser-button__icon-container">
          <img
            className="tracker-chooser-button__icon"
            src={dietDiaperIcon}
            alt=""
          />
        </div>
        <div className="tracker-chooser-button__title">
          Diet & Diaper
        </div>
      </button>
      <button
        className="tracker-chooser-button"
        onClick={() => {
          setExpanded(false);
          formContext.clearFormContext();
          showMilestoneModal();
        }}>
        <div className="tracker-chooser-button__icon-container">
          <img
            className="tracker-chooser-button__icon"
            src={milestoneIcon}
            alt=""
          />
        </div>
        <div className="tracker-chooser-button__title">
          Milestones
        </div>
      </button>
      <button
        className="tracker-chooser-button"
        onClick={() => {
          setExpanded(false);
          formContext.clearFormContext();
          showGrowthModal();
        }}>
        <div className="tracker-chooser-button__icon-container">
          <img
            className="tracker-chooser-button__icon"
            src={growthIcon}
            alt=""
          />
        </div>
        <div className="tracker-chooser-button__title">
          {t('tracker.growth')}
        </div>
      </button>
    </div>
  );
}

TrackerChooser.propTypes = {
  showMilestoneModal: PropTypes.func,
  showDietDiaperModal: PropTypes.func,
  showGrowthModal: PropTypes.func,
  showVisitationModal: PropTypes.func,
  showSleepModal: PropTypes.func,
  visible: PropTypes.bool,
  t: PropTypes.func
};

TrackerChooser.defaultProps = {
  showMilestoneModal: () => {},
  showDietDiaperModal: () => {},
  showGrowthModal: () => {},
  showVisitationModal: () => {},
  showSleepModal: () => {},
  visible: false,
  t: () => {}
};

export default translate()(TrackerChooser);



// WEBPACK FOOTER //
// ./src/components/ActivityTracker/TrackerChooser.js